// Libs
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Utils
import traverse from 'fc-utils/traverse'

// Components
import SelectCoordinateMessage from './SelectCoordinateMessage'
import { Pane } from 'react-leaflet'
import MapInteractiveTools from '@farmersedge/map-interactive-tools'

// Container
import spatialManagerContainer from '../containers/SpatialManager'

// Constants
import { ACTIVE_BUTTON } from '../constants'

// Styles
import { white } from 'fc-styles/src/colors'

const componentStyle = {
  zIndex: 2000,
  display: 'block',
}

const toolBarStyle = {
  position: 'static',
  backgroundColor: white(),
  zIndex: 500,
  // boxShadow: '0 -1px 1px rgba(0,0,0,0.2)',
}

// Object Traversers
const getSelectedSpatial = traverse(['props', 'selectedSpatial'])
const getGeoJSON = traverse(['props', 'selectedSpatial', 'geoJSON'])

// Exports
export class SpatialManager extends Component {
  constructor () {
    super()

    this.onCreateSpatial = this.onCreateSpatial.bind(this)
    this.onUpdateSpatial = this.onUpdateSpatial.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.trackOps = this.trackOps.bind(this)
  }

  onCreateSpatial () {
    this.props.createSpatial({
      spatial: {
        ...this.props.selectedSpatial,
      },
    })
  }

  onUpdateSpatial (geoJSON) {
    this.props.updateSpatial({
      spatial: {
        ...this.props.selectedSpatial,
        geoJSON,
      },
    })
  }

  onSubmit () {
    this.props.submitSpatial({
      spatial: this.props.selectedSpatial,
    })
  }

  trackOps (operation) {
    if (operation) {
      this.props.toggleActiveToolsOp(!!operation[ACTIVE_BUTTON])
    }
  }

  renderContent () {
    const selectedSpatial = getSelectedSpatial(this)
    if (!selectedSpatial) {
      if (this.props.selectPoint) {
        return (
          (
            <SelectCoordinateMessage
              onCreateSpatial={this.onCreateSpatial}
            />
          )
        )
      }

      return null
    }

    return (
      <div style={toolBarStyle}>
        <MapInteractiveTools
          hiddenOptions={[MapInteractiveTools.Draw.Polyline, MapInteractiveTools.Draw.Marker]}
          geoJsons={getGeoJSON(this)}
          onChange={this.onUpdateSpatial}
          onActiveOperation={this.trackOps}
          submitBarVisible={false}
        />
      </div>
    )
  }

  render () {
    return (
      <Pane name='map-interactive-tools'>
        <div style={componentStyle}>
          {this.renderContent()}
        </div>
      </Pane>
    )
  }
}

SpatialManager.propTypes = {
  selectedSpatial: PropTypes.object,
  // addSpatial: PropTypes.func.isRequired,
  updateSpatial: PropTypes.func.isRequired,
  // removeSpatial: PropTypes.func.isRequired,
  createSpatial: PropTypes.func.isRequired,
  // toggleEditingSpatial: PropTypes.func.isRequired,
  // clearSelectedSpatial: PropTypes.func.isRequired,
  submitSpatial: PropTypes.func.isRequired,
  selectPoint: PropTypes.bool,
  toggleActiveToolsOp: PropTypes.func.isRequired,
}

export default spatialManagerContainer(SpatialManager)
